module.exports = __webpack_public_path__ + "8b0ff540d8a793c2ca113243ec98c3cd.eot";


//////////////////
// WEBPACK FOOTER
// ./App/assets/camunda/fonts/opensans-regular-webfont.eot
// module id = 70
// module chunks = 0